import React from 'react';
import { Link } from 'react-router-dom';
import myImage from '../../../images/triggeringcondition.png';
import myImage1 from '../../../images/hazard_harm.png';
import myImage2 from '../../../images/hazardous_behavior.png';

const SGMain = () => {
  return (
    <div className="page-content">
      <h3>SOTIF 위험분석을 통한 시나리오 도출</h3>
      <div className="content-section">
        <h5>시스템 개요</h5>
        <p>자율주행 차량의 사고 피해(Harm) 발생 과정 및 구조를 Hazardous Behavior, Hazard, Scenario, <br/>
        Hazardous Event, Triggering Condition, Harm이라는 개념간의 관계를 통해 정의하고 표현한다</p>
        <p/>
        <img 
          src={myImage1} 
          alt="로컬 이미지 예시" 
          style={{ width: '80%', height: 'auto' }} 
        />
        <p>Figure1. Hazard와 Harm 발생의 관계</p>
        <img 
          src={myImage2} 
          alt="로컬 이미지 예시" 
          style={{ width: '80%', height: 'auto' }} 
        />
        <p>Figure2. Triggering Condition과 Hazardous Behavior의 관계</p>
      </div>
      <div className="content-section">
        <h5>분석과정</h5>
        <p>SOTIF 개념에 의거하여 Hazardous Behavior, Hazard, Scenario, Triggering Condition을 도출함으로써 위험 분석을 수행.</p>
        <ul>
          <li>SOTIF 위험(Hazard) 식별 및 평가</li>
          <li>위험 유발 트리거 이벤트 (Triggering Event) 도출</li>
        </ul>
        <img 
          src={myImage} 
          alt="로컬 이미지 예시" 
          style={{ width: '80%', height: 'auto' }} 
        />

      </div>
    </div>
  );
};

export default SGMain;